import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  SelectableMode,
  SelectableSettings,
} from '@progress/kendo-angular-grid';
import { NotificationService } from '@progress/kendo-angular-notification';
import { startWith, takeUntil } from 'rxjs';
import { EvaluationService } from 'src/app/modules/evaluations/services/evaluation.service';
import {
  dialogAnimationDuration,
  dialogTimer,
} from '../../constants/dialog-specs';
import { NOTIFICATION_MESSAGES } from '../../constants/notification-messages';
import { Reason } from '../../interfaces/reason';
import { SubmitCancelMeetingModel } from '../../models/cancel-meeting-model/submit-cancel-meeting-model';
import { ContributorService } from '../../services/contributor-service';
import { AbstractComponent } from '../abstract-component';
import { HOURS, MINUTES, MS, SECONDS } from '../../constants/time-constants';

@Component({
    selector: 'app-cancel-meeting',
    templateUrl: './cancel-meeting.component.html',
    styleUrls: ['./cancel-meeting.component.scss'],
    standalone: false
})
export class CancelMeetingComponent
  extends AbstractComponent
  implements OnInit
{
  // TODO: Right now we are not changing name of this dialog as we need to change in the entire application
  @Output() close: EventEmitter<void> = new EventEmitter<void>();
  @Input() studentSk: string;
  reason: Reason[] = [
    {
      id: 1,
      description: 'Other',
    },
  ];
  // TODO: Define and use a proper datatype instead of 'any'
  public gridData: any[] = [];
  public checkboxOnly: boolean = false;
  public mode: SelectableMode = 'multiple';
  public drag: boolean = false;
  public selectableSettings: SelectableSettings;
  form: FormGroup;
  showAddInformation: boolean;
  // TODO: Define and use a proper datatype instead of 'any'
  selectedItems: any[] = [];
  // TODO: Define and use a proper datatype instead of 'any'
  uniqueArray: any[] = [];
  readonly otherReasonsId: number = 1;
  readonly singleStatus: string = 'single';

  constructor(
    private evaluationService: EvaluationService<SubmitCancelMeetingModel>,
    private contributorService: ContributorService,
    private notificationService: NotificationService
  ) {
    super();
    this.setSelectableSettings();

    this.form = new FormGroup({
      reason: new FormControl(''),
      otherReason: new FormControl(''),
    });
  }
  ngOnInit(): void {
    // TODO: Specify `data` with a specific type once the API response is known
    this.evaluationService
      .getScheduleMeetingList(this.studentSk)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((data) => {
        this.gridData = data;
      });
    // TODO: Specify `value` with a specific type and replace any once the API response is known
    this.form
      .get('reason')
      ?.valueChanges.pipe(
        takeUntil(this.componentDestroyed),
        startWith(this.form.get('reason')?.value)
      )
      .subscribe((value: any) => {
        if (value?.id === this.otherReasonsId) {
          this.showAddInformation = true;
        } else {
          this.showAddInformation = false;
        }
      });
  }

  public setSelectableSettings(): void {
    if (this.checkboxOnly || this.mode === this.singleStatus) {
      this.drag = false;
    }

    this.selectableSettings = {
      checkboxOnly: this.checkboxOnly,
      mode: this.mode,
      drag: this.drag,
    };
  }

  // TODO: dataItem[...] is more of javascript code rather than typescript. We should be using the dot-notation as opposed to the bracket notation and this will be fixed later on.
  handleSelectionChange(event: Event, dataItem: any): void {
    dataItem.isSelected = (event.target as HTMLInputElement).checked;
  }

  getSelectedMeetingSk(): number[] {
    // TODO: Define proper interface for selectedRows
    const selectedRows = this.gridData.filter((item) => item.isSelected);
    return selectedRows.map((item) => item.meetingSk);
  }

  submit(): void {
    const meetingDetails: number[] = this.getSelectedMeetingSk();
    const formDatalist: SubmitCancelMeetingModel = new SubmitCancelMeetingModel(
      {
        ...this.form.value,
        meetingSk: meetingDetails,
      }
    );
    // TODO: Specify `data` with a specific type once the API response is known
    this.contributorService
      .submitCancelMeetingRequest(formDatalist)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((data) => {
        if (data) {
          this.notificationService.show({
            content: NOTIFICATION_MESSAGES.submitSuccess,
            cssClass: 'notification-success',
            hideAfter: dialogTimer,
            position: { horizontal: 'center', vertical: 'top' },
            animation: { type: 'slide', duration: dialogAnimationDuration },
            type: { style: 'success', icon: true },
          });
          this.close.next();
        }
      });
  }

  onCancel(): void {
    this.close.next();
  }

  public afterOnDestroy(): void {
    // afterOnDestroy
  }

  // TODO: dataItem[...] is more of javascript code rather than typescript. We should be using the dot-notation as opposed to the bracket notation and this will be fixed later on.
  checkIfDisabled(dataItem: any): boolean {
    const today: Date = new Date();
    today.setHours(HOURS, MINUTES, SECONDS, MS);

    const schlDate: Date = new Date(dataItem?.origScheduleDt);
    schlDate.setHours(HOURS, MINUTES, SECONDS, MS);
    return !(schlDate > today);
  }
}
